import { Command, AssertV, AddSchema, Schema, GetSchemaJSON, AssertValidate } from "mobx-firelink";
import { GetSeed } from "Store/firebase/seeds";
const MTName = "Seed";
AddSchema(`Update${MTName}_payload`, [MTName], () => ({
    properties: {
        id: { $ref: "UUID" },
        updates: Schema({
            properties: GetSchemaJSON("Seed").properties.Including("text", "attributeLevels"),
        }),
    },
    required: ["id", "updates"],
}));
//@UserEdit // temp removed, so only one change in update, so completes faster (batches are slow atm, for some reason)
export class UpdateSeed extends Command {
    Validate() {
        AssertValidate("UpdateSeed_payload", this.payload, `Payload invalid`);
        let { id, updates } = this.payload;
        this.oldData = GetSeed(id);
        AssertV(this.oldData, "oldData is null.");
        this.newData = { ...this.oldData, ...updates };
        //this.newData.editedAt = Date.now();
        AssertValidate("Seed", this.newData, `New seed-data invalid`);
    }
    GetDBUpdates() {
        let { id } = this.payload;
        let updates = {};
        updates[`seeds/${id}`] = this.newData;
        return updates;
    }
}
